import { cn } from "../lib/utils";
import { AttachmentItem } from "./attachment-item";

type Attachment = {
  id: string;
  name: string;
  canDelete?: boolean;
  onDeleteClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
};
export type ActivityAttachmentsItemProps = {
  attachments: Attachment[];
  onAttachmentClick?: (id: string) => void;
  className?: string;
};

const ActivityAttachmentsItem: React.FC<ActivityAttachmentsItemProps> = ({
  attachments,
  onAttachmentClick,
  className,
}) => {
  return (
    <>
      {attachments.length > 0 && (
        <div className={cn("space-y-2", className)}>
          {attachments.map((a) => (
            <AttachmentItem
              key={a.id}
              filename={decodeURIComponent(a.name)}
              onFileClick={
                onAttachmentClick ? () => onAttachmentClick(a.id) : undefined
              }
              loading={a.loading}
              onDeleteClick={a.onDeleteClick}
              canDelete={a.canDelete}
              className="w-full"
            />
          ))}
        </div>
      )}
    </>
  );
};

export { ActivityAttachmentsItem };
